import { Injectable, inject } from '@angular/core';
import { liveQuery } from 'dexie';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Repository } from 'typeorm';
import { User } from '../models/user.model';
import { AuthService } from './auth.service';
import { DexieDatabaseService } from './dexieIndexDB.service';
import { PropertyService } from './property.service';

@Injectable({
  providedIn: 'root'
})
export class DropDownService {
  private auth = inject(AuthService);
  private database = inject(DexieDatabaseService);
  private propertyService = inject(PropertyService);


  public landuseTypes = liveQuery(() => this.database.landUseTypes.toArray())
  public enterpriseTypes = liveQuery(() => this.database.enterpriseTypes.toArray())


  private userSub: Subscription;

  private databaseSub: Subscription;

  user: User


  constructor() {
    const auth = this.auth;


    this.userSub = auth.user.subscribe(user => {
      this.user = user;
    });


   }

}
